module.exports = __webpack_public_path__ + "static/media/tv.6f7fa704.svg";